const isInternalPath = (path) =>
  typeof path === "string" && /^\/(?!\/)/.test(path);

export const resolvePreviewReturn = (
  location,
  fallbackPath,
  fallbackLabel
) => {
  const previewReturn = location?.state?.previewReturn;

  if (
    isInternalPath(previewReturn?.path) &&
    typeof previewReturn?.label === "string" &&
    previewReturn.label.trim()
  ) {
    return {
      path: previewReturn.path,
      label: previewReturn.label.trim(),
    };
  }

  return { path: fallbackPath, label: fallbackLabel };
};
